import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackSignOut = () => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    ...getEnvironmentData()
  };

  posthog.capture('sign_out', eventData);
  track('sign_out', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('ViewContent', {
      content_name: 'sign_out',
      content_type: 'product',
      content_id: 'user_signout'
    });
  }
}; 